/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class MarginType {
  static initClass() {
    this.defaultBaseAmount = 1100;

    this.baseTypes = {
      fixed: '固定',
      percentage: '歩合'
    };
  }

  static calcDefaultMarginAmount(peopleNum, sectionNum) {
    if (sectionNum == null) {
      sectionNum = 1;
    }
    return MarginType.defaultBaseAmount * peopleNum * sectionNum;
  }

  constructor(args) {
    args = snakeToCamelObject(args);
    _.assign(this, args);

    if (!this.baseType) {
      this.baseType = 'fixed';
    }
    if (typeof args.baseAmount !== 'number') {
      this.baseAmount = MarginType.defaultBaseAmount;
    }
    if (!this.category) {
      this.category = 'domestic';
    }
  }

  setBaseType(value) {
    this.baseType = value;
    return app.render();
  }

  setBaseAmount(value) {
    this.baseAmount = value;
    return app.render();
  }

  baseTypeText() {
    return MarginType.baseTypes[this.baseType];
  }

  baseAmountSuffix() {
    switch (this.baseType) {
      case 'fixed':
        return '円';
      case 'percentage':
        return '％';
    }
  }

  baseAmountText() {
    return this.baseAmount + this.baseAmountSuffix();
  }

  submitParams() {
    return {
      id: this.id,
      base_type: this.baseType,
      base_amount: this.baseAmount,
      category: this.category
    };
  }

  calcMarginAmount(price, peopleNum, sectionNum) {
    if (sectionNum == null) {
      sectionNum = 1;
    }
    const target = this.baseType === 'fixed' ? peopleNum : price;
    const base = this.baseType === 'fixed' ? this.baseAmount * sectionNum : this.baseAmount / 100.0;
    return _.ceil(target * base);
  }

  calcBulkTicketFee(ticket) {
    if (this.baseType === 'fixed') {
      return this.baseAmount;
    } else {
      return (ticket.price * this.baseAmount) / 100;
    }
  }

  describe(price, peopleNum, sectionNum) {
    if (sectionNum == null) {
      sectionNum = 1;
    }
    switch (this.baseType) {
      case 'fixed':
        return formatPrice(this.baseAmount * sectionNum) + ' × ' + peopleNum + '名';
      case 'percentage':
        return formatPrice(price) + ' × ' + this.baseAmount + '％';
    }
  }

  amount(price, sectionNum) {
    if (sectionNum == null) {
      sectionNum = 1;
    }
    switch (this.baseType) {
      case 'fixed':
        return this.baseAmount * sectionNum;
      case 'percentage':
        return price;
    }
  }

  isDomestic() {
    return this.category === 'domestic';
  }

  isForeign() {
    return this.category === 'foreign';
  }
}
MarginType.initClass();

module.exports = MarginType;
